import React from "react";
import { Controller } from "react-hook-form";
import MonetaryInput from "components/monetary-input/MonetaryInput";
import { IControlledMonetaryInputProps } from "./definitions";

const ControlledMonetaryInput: React.FC<IControlledMonetaryInputProps> = ({
  name,
  control,
  currencySign = "$",
  title = "",
  rules,
  defaultValue = "",
  refreshChanges,
  formatWithCommas = false,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field: { onChange, value, name: fieldName } }) => (
        <MonetaryInput
          name={fieldName}
          title={title}
          value={value || ""}
          currencySign={currencySign}
          onChange={onChange}
          refreshChanges={refreshChanges}
          formatWithCommas={formatWithCommas}
        />
      )}
    />
  );
};

export default ControlledMonetaryInput;
